import React from "react";
import { usePhoneMode } from "../../hooks";

export default function ContentContainer({ children }) {
    const { isMobile } = usePhoneMode();
    return (
        <div style={{
            overflowY: 'auto',
            overflowX: 'hidden',
            height: 'calc(100vh - 10.1em)',
            width: '100vw',
            marginTop: !isMobile ? '1.1em' : null
        }}>
            {children}
        </div>
    );
}